import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from "react-helmet";

import icon from './imgs/icon_page_not_found.svg';
import './NoMatch.css';

class NoMatch extends Component {
  render() {
    return (
      <div className="NoMatch">
        <Helmet>
          <title>Page not found - Qbates</title>
          <meta name="description" content="Oops! Page not found" />
        </Helmet>
        <div className="SubHeader">
          <h2>Page not found</h2>
        </div>
        <div className="container">
          <div className="image">
            <img src={icon} alt="404"/>
          </div>
          <div className="text">
            <h2>Oops! Page not found</h2>
            <p>Error code is 404, you may enter a wrong site address, try again.</p>
          </div>
        </div>
        <div className="button">
          <Link to="/"><button>REDIRECT TO HOME</button></Link>
        </div>
      </div>
    )
  }
}

export default NoMatch;


// WEBPACK FOOTER //
// ./src/Containers/NoMatch/NoMatch.js